import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiCheck, FiX, FiInfo } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

let notificationId = 0;
const notifications = [];
const listeners = [];

export const showNotification = (message, type = 'info', duration = 3000) => {
  const id = ++notificationId;
  const notification = { id, message, type, duration };
  notifications.push(notification);
  listeners.forEach(listener => listener([...notifications]));

  // 自動移除
  setTimeout(() => {
    removeNotification(id);
  }, duration);

  return id;
};

export const removeNotification = (id) => {
  const index = notifications.findIndex(n => n.id === id);
  if (index > -1) {
    notifications.splice(index, 1);
    listeners.forEach(listener => listener([...notifications]));
  }
};

const NotificationContainer = () => {
  const [notificationList, setNotificationList] = useState([]);

  useEffect(() => {
    const updateNotifications = (newNotifications) => {
      setNotificationList(newNotifications);
    };
    listeners.push(updateNotifications);
    return () => {
      const index = listeners.indexOf(updateNotifications);
      if (index > -1) {
        listeners.splice(index, 1);
      }
    };
  }, []);

  const getIcon = (type) => {
    switch (type) {
      case 'success': return FiCheck;
      case 'error': return FiX;
      default: return FiInfo;
    }
  };

  const getColors = (type) => {
    switch (type) {
      case 'success': return 'bg-green-500 text-white';
      case 'error': return 'bg-red-500 text-white';
      case 'warning': return 'bg-yellow-500 text-white';
      default: return 'bg-blue-500 text-white';
    }
  };

  return (
    // 🔥 修正: 將 Notification z-index 提升到 2000，確保顯示在 Modal (z-1000) 之上
    <div className="fixed top-4 right-4 z-[2000] space-y-2">
      <AnimatePresence>
        {notificationList.map((notification) => (
          <motion.div
            key={notification.id}
            className={`notification flex items-center gap-3 px-4 py-3 rounded-lg shadow-lg max-w-sm ${getColors(notification.type)}`}
            initial={{ opacity: 0, x: 100, scale: 0.8 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: 100, scale: 0.8 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
          >
            <SafeIcon icon={getIcon(notification.type)} className="text-lg flex-shrink-0" />
            <span className="text-sm font-medium">{notification.message}</span>
            <button
              onClick={() => removeNotification(notification.id)}
              className="ml-auto hover:opacity-80 transition-opacity"
              aria-label="關閉通知"
            >
              <SafeIcon icon={FiX} className="text-sm" />
            </button>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default NotificationContainer;